// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12974":"skin-copy","50169":"aria-labels"}[chunkId] || chunkId) + "-" + {"12974":"9a9db159dce37bb8543a","13325":"f3b0e84895050ececddf","43492":"fccd9ff7bf918ac9f865","47382":"cfb63be3df41e9ce2696","50169":"171d76617645d3fa18bd","64215":"e86d38c03b751321218b"}[chunkId] + ".min.js";
};